var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.details.schoolId)?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"verification-icon",class:{
        verified: _vm.isVerified,
        ignored: _vm.isIgnored,
        danger: _vm.isUnverified,
        warning: _vm.isPending,
    },attrs:{"title":_vm.verificationStatusText},on:{"click":function($event){$event.preventDefault();return _vm.handleVerificationIconClick.apply(null, arguments)}}},[_c('img',{staticClass:"img-icon",attrs:{"src":_vm.verificationStatusIcon}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }